/* eslint-disable */

/* tslint:disable */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType
} from 'axios';
import axios from 'axios';

export type Labels = Record<string, string>;

export type PathSpecs = {
  path?: string;
  include?: string;
  exclude?: string;
  map?: {
    match_pattern?: string;
    replace_pattern?: string;
  };
}[];

export interface DownloadOptions {
  archive?: boolean;
  archive_name?: string;
}

export interface TransferOptions {
  archive?: boolean;
  path_prefix?: string;
  archive_name?: string;
}

export interface Store {
  /** @format uuid */
  id?: string;
  name?: string;
  type?: 'GCS' | 'S3' | 'AZBLOB';
  configs?: {
    bucket?: string;
    region?: string;
    path_prefix?: string;
  };
  labels?: Labels;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
}

export type NewStore = NewStoreBase;

export type NewS3Store = NewStoreBase & {
  secrets?: {
    access_key_id?: string;
    secret_access_key?: string;
  };
};

export type NewGCSStore = NewStoreBase & {
  secrets?: {
    project_id?: string;
    service_account_credentials?: string;
  };
};

export type NewAZBLOBStore = NewStoreBase & {
  secrets?: {
    tenant_id?: string;
    client_id?: string;
    client_secret?: string;
  };
};

export type NewStoreBase = BaseNewStoreBase &
  (
    | BaseNewStoreBaseTypeMapping<'S3', NewS3Store>
    | BaseNewStoreBaseTypeMapping<'GCS', NewGCSStore>
    | BaseNewStoreBaseTypeMapping<'AZBLOB', NewAZBLOBStore>
  );

export interface Transfer {
  /** @format uuid */
  id?: string;
  destination?: string;
  path_specs?: PathSpecs;
  options?: TransferOptions;
  labels?: Labels;
  status?: 'CREATED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';
  created_at?: string;
  created_by?: string;
}

export interface NewTransfer {
  destination: string;
  labels?: Labels;
  path_specs: PathSpecs;
  options: TransferOptions;
}

export interface Download {
  /** @format uuid */
  id?: string;
  path_specs?: PathSpecs;
  options?: DownloadOptions;
  labels?: Labels;
  status?: 'CREATED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';
  created_at?: string;
  created_by?: string;
}

export interface NewDownload {
  path_specs: PathSpecs;
  options: DownloadOptions;
  labels?: Labels;
}

export interface NewDownloadLink {
  /**
   * Link expiry time in seconds
   * @default 43200
   */
  expiry?: number;
}

export interface DownloadLink {
  url: string;
  expiry?: number;
}

interface BaseNewStoreBase {
  name: string;
  type: 'GCS' | 'S3' | 'AZBLOB';
  configs: {
    bucket?: string;
    region?: string;
    path_prefix?: string;
  };
  labels?: Labels;
}

type BaseNewStoreBaseTypeMapping<Key, Type> = {
  type: Key;
} & Type;

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || ''
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {})
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path
    });
  };
}

/**
 * @title Courier Service
 * @version 0.1.0
 *
 * API for managing stores and transfer tasks within an organization.
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @name StoresList
     * @summary List stores for organization
     * @request GET:/api/stores
     */
    storesList: (params: RequestParams = {}) =>
      this.request<
        {
          stores?: Store[];
        },
        any
      >({
        path: `/api/stores`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name StoresCreate
     * @summary Create a store
     * @request POST:/api/stores
     */
    storesCreate: (data: NewStore, params: RequestParams = {}) =>
      this.request<Store, any>({
        path: `/api/stores`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name StoresDetail
     * @summary Get store details
     * @request GET:/api/stores/{store_id}
     */
    storesDetail: (storeId: string, params: RequestParams = {}) =>
      this.request<Store, any>({
        path: `/api/stores/${storeId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name StoresDelete
     * @summary Delete store
     * @request DELETE:/api/stores/{store_id}
     */
    storesDelete: (storeId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/stores/${storeId}`,
        method: 'DELETE',
        ...params
      })
  };
  internal = {
    /**
     * No description
     *
     * @name TransfersCreate
     * @summary Create a transfer task
     * @request POST:/internal/transfers
     */
    transfersCreate: (data: NewTransfer, params: RequestParams = {}) =>
      this.request<Transfer, any>({
        path: `/internal/transfers`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name TransfersList
     * @summary List transfer tasks
     * @request GET:/internal/transfers
     */
    transfersList: (
      query?: {
        /** User labels to use as filter */
        labels?: object;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          transfers?: Transfer[];
        },
        any
      >({
        path: `/internal/transfers`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name TransfersDetail
     * @summary Get a transfer task
     * @request GET:/internal/transfers/{transfer_id}
     */
    transfersDetail: (transferId: string, params: RequestParams = {}) =>
      this.request<Transfer, any>({
        path: `/internal/transfers/${transferId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name TransfersDelete
     * @summary Delete a transfer task
     * @request DELETE:/internal/transfers/{transfer_id}
     */
    transfersDelete: (transferId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/internal/transfers/${transferId}`,
        method: 'DELETE',
        ...params
      }),

    /**
     * No description
     *
     * @name DownloadsCreate
     * @summary Create a download request
     * @request POST:/internal/downloads
     */
    downloadsCreate: (data: NewDownload, params: RequestParams = {}) =>
      this.request<Download, any>({
        path: `/internal/downloads`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name DownloadsList
     * @summary List downloads
     * @request GET:/internal/downloads
     */
    downloadsList: (
      query?: {
        /** User labels to use as filter */
        labels?: object;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          downloads?: Download[];
        },
        any
      >({
        path: `/internal/downloads`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name DownloadsDetail
     * @summary Get a download
     * @request GET:/internal/downloads/{download_id}
     */
    downloadsDetail: (downloadId: string, params: RequestParams = {}) =>
      this.request<Download, any>({
        path: `/internal/downloads/${downloadId}`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @name DownloadsDelete
     * @summary Delete a download
     * @request DELETE:/internal/downloads/{download_id}
     */
    downloadsDelete: (downloadId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/internal/downloads/${downloadId}`,
        method: 'DELETE',
        ...params
      }),

    /**
     * No description
     *
     * @name DownloadsLinkCreate
     * @summary Generate a download link
     * @request POST:/internal/downloads/{download_id}/link
     */
    downloadsLinkCreate: (
      downloadId: string,
      data: NewDownloadLink,
      params: RequestParams = {}
    ) =>
      this.request<DownloadLink, any>({
        path: `/internal/downloads/${downloadId}/link`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  };
}
